import {ChangeDetectionStrategy, Component} from "@angular/core";
import {HeaderComponent} from "../../components/header/header.component";
import {LoginFormComponent} from "../../components/login-form/login-form.component";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HeaderComponent, LoginFormComponent],
})
export class LoginComponent {}
